export const TX_GAS_SET = 'TX_GAS_SET';